import { useEffect, useState } from 'react';
import TabButtonGroup from '../tab-buttons';
import { ConcreteStructureTypes } from '../../../../shared/constants/concrete-structure-types';
import StructureSelectDisclaimerTable from '../table/desktop';
import FireRatingSelect from '../mobile-view-select';
import useIsMobile from '../../../../shared/hooks/useIsMobile';
import MobileViewTable from '../table/mobile';

export const enum Tabs {
  SimpleBeam = 0,
  ContinuousBeam = 1,
}

const BeamRequiredAxisTable = () => {
  const [tabSelected, setTabSelected] = useState<Tabs>(Tabs.SimpleBeam);
  const [selectedFireRatingIndex, setSelectedFireRatingIndex] = useState(0);

  const isMobile = useIsMobile();

  useEffect(() => {
    setSelectedFireRatingIndex(0);
  }, [tabSelected]);

  return (
    <>
      <TabButtonGroup setTabSelected={setTabSelected} tabSelected={tabSelected}/>
      {
        isMobile ? (<>
          <FireRatingSelect fireRatingIndex={selectedFireRatingIndex} setFireRatingIndex={setSelectedFireRatingIndex} />
          <MobileViewTable
            structureName={tabSelected === 0 ? ConcreteStructureTypes.BeamSimple : ConcreteStructureTypes.BeamContinuous}
            fireResistanceIndex={selectedFireRatingIndex} />
        </>) : (<>
          {tabSelected === Tabs.SimpleBeam && (
            <StructureSelectDisclaimerTable
              structureName={ConcreteStructureTypes.BeamSimple}
            />
          )}
          {tabSelected === Tabs.ContinuousBeam && (
            <StructureSelectDisclaimerTable
              structureName={ConcreteStructureTypes.BeamContinuous}
            />
          )}
        </>)
      }
    </>
  );
};

export default BeamRequiredAxisTable;